import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserSettingsComponent } from './user-settings.component';

// Material
import {
	MatInputModule,
	MatPaginatorModule,
	MatProgressSpinnerModule,
	MatSortModule,
	MatTableModule,
	MatSelectModule,
	MatMenuModule,
	MatProgressBarModule,
	MatButtonModule,
	MatCheckboxModule,
	MatDialogModule,
	MatTabsModule,
	MatNativeDateModule,
	MatCardModule,
	MatRadioModule,
	MatIconModule,
	MatDatepickerModule,
	MatAutocompleteModule,
	MAT_DIALOG_DEFAULT_OPTIONS,
	MatSnackBarModule,
	MatTooltipModule,
	MatChip,
	MatChipsModule,
	MatDivider,
	MatDividerModule,
	MatExpansionModule,
	MatSlideToggleModule
} from '@angular/material';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpClientModule } from '@angular/common/http';
import { CoreModule } from '../../../../app/core/core.module';
import { Routes, RouterModule } from '@angular/router';
import { ProfileComponent } from './profile/profile.component';
import { TranslateModule } from '@ngx-translate/core';
import { NotificationsComponent } from './notifications/notifications.component';
import { NotifyDialogComponent } from './notifications/notify-dialog/notify-dialog.component';
import { PartialsModule } from '../../partials/partials.module';

const routes: Routes = [
	{
		path: '',
		component: UserSettingsComponent,
		children: [
			{
				path: '',
				redirectTo: 'profile',
				pathMatch: 'full'
			},
			{
				path: 'profile',
				component: ProfileComponent
			},
			{
				path: 'notification',
				component: NotificationsComponent
			}
		]
	}
];
@NgModule({
  declarations: [UserSettingsComponent, ProfileComponent, NotificationsComponent, NotifyDialogComponent],
  imports: [
	RouterModule.forChild(routes),
	FormsModule,
	TranslateModule.forChild(),
	ReactiveFormsModule,
	CommonModule,
	NgbModule,
	HttpClientModule,
	CoreModule,
	PartialsModule,
	MatDialogModule,
	MatButtonModule,
	MatMenuModule,
	MatSelectModule,
	MatChipsModule,
	MatDividerModule,
	MatInputModule,
	MatTableModule,
	MatAutocompleteModule,
	MatRadioModule,
	MatIconModule,
	MatNativeDateModule,
	MatProgressBarModule,
	MatDatepickerModule,
	MatCardModule,
	MatPaginatorModule,
	MatSortModule,
	MatCheckboxModule,
	MatProgressSpinnerModule,
	MatExpansionModule,
	MatSnackBarModule,
	MatTabsModule,
	MatTooltipModule,
	MatSlideToggleModule
  ],
  entryComponents: [
	  NotifyDialogComponent
  ]
})
export class UserSettingsModule { }
